import { BiLanguageId } from "@globals/enums/BiLanguageAndCountryId";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export class DayJsSetupHandler {
  /**
   * Determines the locale to use for DayJs and dynamically imports that locale, adds it to DayJs and sets the timezone, too.
   */
  public static async setDayJsLocaleAndTimezone(languageId: BiLanguageId) {
    let locale: "da" | "sv" | "en-gb" | "fi" | "nb";

    switch (languageId) {
      case BiLanguageId.DK:
        locale = "da";
        break;
      case BiLanguageId.SE:
        locale = "sv";
        break;
      case BiLanguageId.EN:
        locale = "en-gb";
        break;
      case BiLanguageId.FI:
        locale = "fi";
        break;
      case BiLanguageId.NO:
        locale = "nb"; // "nb" is Norsk bokmål which is supported by DayJs
        break;
      default:
        locale = "en-gb";
    }

    return await import(`dayjs/locale/${locale}.js`).then(() => {
      dayjs.locale(locale);
      dayjs.tz.setDefault(dayjs.tz.guess());
    });
  }
}
